import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import LithuaniaReqMain from "./LithuaniaReqMain";

const LithuaniaReq = () => {
  return (
    <div className="uaeReqContainer">
      <LithuaniaReqMain />
    </div>
  );
};

export default LithuaniaReq;
